import { Flex, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H4 } from "src/atoms/typography";
import { VideoErrorType } from "src/modules/parent-station/lib/createVideoErrorManager";
import imageSrc from "./videoff.svg";

export default function ErrorMode({ videoError }) {
  const { t } = useTranslation();
  if (videoError !== VideoErrorType.NOT_INCOMMING) return null;
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      bg="black20"
      width="100%"
      position="absolute"
      top="38px"
      height="calc(100% - 38px)"
      sx={{
        backdropFilter: "blur(14px)"
      }}
    >
      <Image width={["64px", "90px", "102px"]} src={imageSrc} />
      <H4
        mt="20px"
        width="35vw"
        color="white54"
        textAlign="center"
        fontSize={[14, 20, 24]}
        lineHeight={["16px", "22px", "28px"]}
        letterSpacing={["0.15px", "0.2px", "0.28px"]}
      >
        {t("parentStation.videoErrors.notIncomming.text")}
      </H4>
    </Flex>
  );
}
